<div class="main-container">
  <div class="container">
    <h3 class="title"></h3>
    <app-settings-card-payments-section
      [sectionTitle]="'advanced-pages.documents.title' | i18next"
      [description]="'advanced-pages.documents.description' | i18next"
    >
      <app-business-document-upload
        [sampleImageUrl]="sampleImageUrl"
        [labelText]="documentTitle"
        [fileControl]="fileControl"
        [documentURL]="documentURL"
        [errors]="errors"
        [validationMessage]="validationMessage"
        [fromTh]="fromTh"
      />
    </app-settings-card-payments-section>
  </div>
  <!-- {{fileControl.untouched}}--{{errors}}--{{fileControl.untouched || (errors||[]).length>0}} -->
  <!-- <div
  class="tw-fixed tw-bottom-0 tw-left-0 tw-px-5 tw-py-4 tw-gap-4 tw-w-full"
  >   

</div> -->
</div>

<app-cta-buttons
  currentPage="business-documents"
  [pageNames]="advancedPages"
  [backButton]="false"
  tier="advanced"
  [disabled]="fileControl.untouched || (errors || []).length > 0 || (fileControl.value === 'undefined' || fileControl.value === null )"
  (nextEvent)="onNextPressed()"
  [nextCallback]="onNextPressed"
  [isLoading]="isLoading"
  [additionalparams]="advancedPagesParams"
/>
